/* GOB DRAWER SKIN — V154, 2026-10-19. Companion to gob-drawer-skin.css.
   Two small DOM touches the stylesheet cannot do on its own:
   1. (the item count next to the title is V153's .gx-count, restyled in CSS)
   2. Protection lines: "Shipping Insurance ·€2,99" becomes a name and a price
      in their own boxes, so the price can sit on the right edge.
   Idempotent; re-run after every drawer paint. No polling. */
(function () {
  'use strict';
  var D = document;
  function q(s, r) { return (r || D).querySelector(s); }
  function qa(s, r) { return [].slice.call((r || D).querySelectorAll(s)); }

  function addons() {
    qa('#HeaderCart #worry_free .title, #HeaderCart #extended_warranty .title').forEach(function (t) {
      if (t.querySelector('.gx-nm')) return;
      var name = '';
      [].slice.call(t.childNodes).forEach(function (n) {
        if (n.nodeType === 3) { name += n.textContent; n.parentNode.removeChild(n); }
      });
      name = name.replace(/[·•]\s*$/, '').replace(/\s+/g, ' ').trim();
      var s = D.createElement('span'); s.className = 'gx-nm'; s.textContent = name;
      t.insertBefore(s, t.firstChild);
      var p = t.querySelector('span[aria-hidden="true"]'); if (p) p.classList.add('gx-pr');
    });
  }

  /* 3. The GOB Club section (sections/gob-club-cart-receipt.liquid) writes its
     own text on every refresh: a "★ " in front of the draw line, amounts from
     Intl in "en" (€67.97 on a store that prints €67,97), and an inline square
     top on Check out (the old "weld"). Fixed the moment it is written — a
     MutationObserver callback runs before the next paint, so nothing flickers. */
  var DEC = null;
  function decimal() {
    if (DEC) return DEC;
    var hit = qa('#HeaderCart .visually-hidden').map(function (e) { return e.textContent; }).join(' ').match(/\d([.,])\d{2}(?!\d)/);
    return (DEC = hit ? hit[1] : null);
  }
  function fixMoney(el) {
    if (!el || decimal() !== ',') return;
    [].slice.call(el.childNodes).forEach(function (n) {
      if (n.nodeType === 1) { fixMoney(n); return; }
      if (n.nodeType !== 3) return;
      var t = n.textContent.replace(/(\d{1,3}(?:,\d{3})*)\.(\d{2})(?!\d)/g, function (m, i, d) { return i.replace(/,/g, '.') + ',' + d; });
      if (t !== n.textContent) n.textContent = t;
    });
  }
  function club() {
    var r = q('#HeaderCart .gobcr'); if (!r) return;
    var gv = q('.gobcr__gv', r);
    if (gv && /^\s*★\s*/.test(gv.textContent)) gv.textContent = gv.textContent.replace(/^\s*★\s*/, '');
    fixMoney(q('.gobcr__h', r)); fixMoney(q('.gobcr__s', r));
    var w = q('#HeaderCart .cart__checkout-wrapper'), b = w && q('[name="checkout"]', w);
    if (w && w.classList.contains('gob-cc-weld')) w.classList.remove('gob-cc-weld');   /* guarded: classList.remove always writes the attribute, which would wake the observer again */
    if (b && (b.style.borderTopLeftRadius || b.style.borderTopRightRadius)) { b.style.removeProperty('border-top-left-radius'); b.style.removeProperty('border-top-right-radius'); }
  }

  var pending = 0;
  function run() {
    if (pending) return;
    pending = requestAnimationFrame(function () { pending = 0; addons(); club(); });
  }

  ['gob:cart-painted', 'cart:updated', 'cart:build', 'cart:open', 'ajaxProduct:added'].forEach(function (ev) {
    D.addEventListener(ev, function () { run(); setTimeout(run, 160); setTimeout(run, 480); });
  });
  D.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('js-qty__num')) run(); }, true);
  function observe() {
    var d = D.getElementById('HeaderCart'); if (!d || !window.MutationObserver) return;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target, e = t.nodeType === 1 ? t : t.parentNode;
        if (e && e.closest && (e.closest('.gobcr') || e.closest('.cart__checkout-wrapper') || e.classList.contains('cart__footer'))) { club(); break; }
      }
      run();
    }).observe(d, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
  }
  function boot() { observe(); run(); club(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', run);
})();
